import { FillImage } from "components/images";
import { Section } from "components/section";
import React from "react";
import { Button } from "ui/button";
import { Diptych, DiptychColumn } from "ui/diptych";
import { TextTitle } from "ui/text";
import diptychImage1 from "../../../../public/assets/platform/event-collection/data-diptych-1.png";
import diptychImage2 from "../../../../public/assets/platform/event-collection/data-diptych-2.png";
import diptychImage3 from "../../../../public/assets/platform/event-collection/data-diptych-3.png";

export function DataCollectionFeatures() {
  return (
    <Section theme="dark" bg="new.gray.950" themeBgColor="new.gray.950">
      <TextTitle
        theme="dark"
        size="lg"
        align="center"
        title="Collect higher quality data — faster"
        mb={{ base: "biggest", md: "huge" }}
      />

      <DiptychColumn>
        <Diptych
          theme="dark"
          size="md"
          direction="left"
          media={
            <FillImage
              src={diptychImage1}
              alt='An illustration showing two examples of data for an event being tracked. One is labeled "Bad" and shows a nonspecific event titled "Purchase." The other is labeled "Good" and shows a more specific event titled "Order Completed."'
            />
          }
          title="Ensure high quality data"
          description="Define data contracts to proactively govern your data and ensure every event meets your expectations before being written to the data warehouse."
          actions={
            <Button hasRightChevron href="/blog/data-contracts-hightouch-events" target="_blank">
              Read about data contracts
            </Button>
          }
        />

        <Diptych
          theme="dark"
          size="md"
          direction="left"
          media={
            <FillImage
              src={diptychImage2}
              alt='An illustration showing a sample of rows of data coming from your data warehouse that includes "Anonymous ID", "SKU", "Category", and "Color" fields. A set of icons for Facebook, Google Analytics, Salesforce, HubSpot, Intercom, and Zendesk are overlayed.'
            />
          }
          title="Track customers across anonymous to known journeys"
          description="Seamlessly integrate with Hightouch's Identity Resolution product to get a holistic view of each customer."
          actions={
            <Button hasRightChevron href="/platform/identity-resolution" target="_blank">
              Learn about IDR
            </Button>
          }
        />

        <Diptych
          theme="dark"
          size="md"
          direction="left"
          media={
            <FillImage
              src={diptychImage3}
              alt='An illustration showing an example code snippet for the Hightouch SDK. The code demonstrates using the "track" function to send an "Order Completed" event with additional metadata for "product_category", "product_id", "price", and "used_promo".'
            />
          }
          title="Migrate painlessly"
          description="Switch your event collection to Hightouch without disruption. Our SDKs are backward compatible with other major event collection providers, and we support flexible data schemas."
          actions={
            <Button hasRightChevron href="/docs/events/migration-guide/overview" target="_blank">
              Read our migration guide
            </Button>
          }
        />
      </DiptychColumn>
    </Section>
  );
}
